import { formatNumberByCountry } from "./formatNumbers";

// Formatea un conteo (entero, sin moneda) con el separador de miles del país.
// Sin `country` disponible, se muestra el número tal cual (fallback seguro).
const formatCount = (n, country) =>
  country ? formatNumberByCountry(n, country, false, 0) : String(n);

// Genera el texto de `showTotal` para la paginación de las tablas, agregando
// "(filtrado de N)" cuando el total mostrado (ya filtrado por búsqueda/columnas)
// difiere del total real sin filtrar. Evita duplicar un contador aparte fuera
// de la tabla (una sola fuente de verdad para el conteo de registros).
export const buildShowTotal =
  (rawLength, unit = "elementos", country) =>
  (total, range) =>
    `${formatCount(range[0], country)}-${formatCount(range[1], country)} de ${formatCount(total, country)} ${unit}` +
    (total !== rawLength ? ` (filtrado de ${formatCount(rawLength, country)})` : "");
